import { localization } from '@ocean/configs'
import { Card, CardType } from 'types/card'
import { CustomerSpecificCategory } from 'core/customerSpecificCategories/types'
import { namespace } from 'modules/virtualClassrooms/common/localization'
import { VirtualEventDetails } from 'modules/virtualClassrooms/common/types/manager'
import { EventCreatorFormParams } from 'modules/virtualClassrooms/manager/EventCreator/types'
import { EventEditorFormParams } from 'modules/virtualClassrooms/manager/EventDetails/types/eventEditor'

const { i18n } = localization

const I18_PATH = `${namespace}:student.events.eventLibrary.categories.uncategorised`

export const UNCATEGORISED_CATEGORY_ID = 'uncategorised'

export const getUncategorisedCategory = (): Card => ({
  id: UNCATEGORISED_CATEGORY_ID,
  name: i18n.t(I18_PATH),
  typeSpecificValues: {
    numberOfEvents: 0,
  },
  result: null,
  itemType: CardType.VirtualEventsCategory,
})

export const getUncategorisedCustomerSpecificCategory = (): CustomerSpecificCategory => ({
  categoryId: UNCATEGORISED_CATEGORY_ID,
  inUse: true,
  name: i18n.t(I18_PATH),
  parentId: null,
  sortCode: -1,
})

export const getNormalizedFormData = (formData: EventCreatorFormParams | EventEditorFormParams) =>
  formData.categoryId === UNCATEGORISED_CATEGORY_ID ? { ...formData, categoryId: null } : formData

export const getNormalizedVirtualEventDetails = (virtualEvent: VirtualEventDetails | undefined) =>
  virtualEvent?.categoryId === null
    ? { ...virtualEvent, categoryId: UNCATEGORISED_CATEGORY_ID }
    : virtualEvent

export const checkIsCategoryNested = (option: CustomerSpecificCategory) => Boolean(option.parentId)
